import {ProjectDocTypeVals} from "./ProjectDocTypes";

export type ProjectDocTypePillBucket =
    | `workingdocs` | `designdocs` | `tor` | `estimate` | `surveyreport`
    | `surveydata` | `permits`;

export interface ProjectDocTypePillStyle {
    bg: string;
    color: string;
}


// Проверить
export const ProjectDocTypePillBuckets: Record<ProjectDocTypePillBucket, ProjectDocTypePillStyle> = {
    workingdocs: {bg: `var(--doctype-workingdocs-bg)`, color: `var(--doctype-workingdocs-color)`},   // Рабочая документация
    designdocs: {bg: `var(--doctype-designdocs-bg)`, color: `var(--doctype-designdocs-color)`},    // Проектная документация
    tor: {bg: `var(--doctype-tor-bg)`, color: `var(--doctype-tor-color)`},           // Техническое задание
    estimate: {bg: `var(--doctype-estimate-bg)`, color: `var(--doctype-estimate-color)`},      // Смета (зарезервирован, нет соответствующего id в ProjectDocTypeVals)
    surveyreport: {bg: `var(--doctype-surveyreport-bg)`, color: `var(--doctype-surveyreport-color)`},  // Отчёт об обследовании
    surveydata: {bg: `var(--doctype-surveydata-bg)`, color: `var(--doctype-surveydata-color)`},    // изыскания/исходные данные
    permits: {bg: `var(--doctype-permits-bg)`, color: `var(--doctype-permits-color)`},       // исходно-разрешительная документация
};

// из комментариев в ProjectDocTypes.ts
const docTypeIdToBucket: Record<number, ProjectDocTypePillBucket> = {
    [ProjectDocTypeVals.TS]: `tor`,
    [ProjectDocTypeVals.TSC]: `tor`,
    [ProjectDocTypeVals.PD]: `designdocs`,
    [ProjectDocTypeVals.PDEdit]: `designdocs`,
    [ProjectDocTypeVals.WD]: `workingdocs`,
    [ProjectDocTypeVals.WDEdit]: `workingdocs`,
    [ProjectDocTypeVals.Executive]: `workingdocs`,
    [ProjectDocTypeVals.II]: `surveydata`,
    [ProjectDocTypeVals.IIEdit]: `surveydata`,
    [ProjectDocTypeVals.OriginalData]: `surveydata`,
    [ProjectDocTypeVals.IPA]: `permits`,
    [ProjectDocTypeVals.IPAEdit]: `permits`,
};

export function getProjectDocTypePillStyle(docTypeId?: number): ProjectDocTypePillStyle {
    const bucket = docTypeId !== undefined ? docTypeIdToBucket[docTypeId] : undefined;
    return ProjectDocTypePillBuckets[bucket ?? `workingdocs`];
}
